<!-- Modals -->
<app-deprecated-modal-form
    #editForm
    [form]="officeForm"
    (save)="onSave()"
    (cancel)="onCancel()"
    headerText="{{ 'company.office.editOfficeDialogHeader' | translate }}"
>
    <app-office-form #officeForm [office]="office"></app-office-form>
</app-deprecated-modal-form>

<app-deprecated-confirmation-dialog
    #confirmDeleteDialog
    [negative]="true"
    [disableAction]="paginator.total > 0"
    [description]="
        (paginator.total > 0
            ? 'company.office.cannotDeleteOfficeWithEmployeesMessage'
            : 'company.office.deleteOfficeConfirmMessage'
        ) | translate
    "
    [label]="'company.office.deleteOfficeDialogButtonLabel' | translate"
></app-deprecated-confirmation-dialog>

<div class="ui basic segment" [class.loading]="isLoading">
    <app-header
        *permission="editPermission; all: true"
        title="{{ 'company.office.header' | translate }}"
        [back]="true"
        [contextMenu]="true"
        contextMenuType="material"
    >
        <button *permission="editPermission; all: true" mat-menu-item (click)="onDelete()">
            {{ 'company.office.deleteOfficeButtonLabel' | translate }}
        </button>
    </app-header>

    <div class="ui google raised segment" [class.loading]="_googleImage === '' && !isLoading">
        <img [attr.src]="getGoogleMapsImage()" />
    </div>

    <ui-card>
        <app-segment-header
            [title]="office.addressLine1"
            (edit)="editForm.show()"
            [editPermission]="editPermission"
        ></app-segment-header>

        <table class="mat-table office-details-table">
            <tr class="mat-row">
                <td class="mat-cell label">{{ 'company.office.nameLabel' | translate | i18nLabel }}</td>
                <td class="mat-cell value">{{ office.name }}</td>
            </tr>
            <tr class="mat-row">
                <td class="mat-cell label">{{ 'company.office.addressLabel' | translate | i18nLabel }}</td>
                <td class="mat-cell value">{{ office.addressLine1 }}</td>
            </tr>
            <tr class="mat-row">
                <td class="mat-cell label">{{ 'company.office.unitSuiteLabel' | translate | i18nLabel }}</td>
                <td class="mat-cell value">{{ office.addressLine2 }}</td>
            </tr>
            <tr class="mat-row">
                <td class="mat-cell label">{{ 'company.office.cityLabel' | translate | i18nLabel }}</td>
                <td class="mat-cell value">{{ office.city }}</td>
            </tr>
            <tr class="mat-row">
                <td class="mat-cell label">{{ 'company.office.provinceStateLabel' | translate | i18nLabel }}</td>
                <td class="mat-cell value">{{ office.provinceDisplayName }}</td>
            </tr>
            <tr class="mat-row">
                <td class="mat-cell label">{{ 'company.office.countryLabel' | translate | i18nLabel }}</td>
                <td class="mat-cell value">{{ office.country }}</td>
            </tr>
            <tr class="mat-row">
                <td class="mat-cell label">{{ 'company.office.postalZipCodeLabel' | translate | i18nLabel }}</td>
                <td class="mat-cell value">{{ office.postalCode }}</td>
            </tr>
        </table>
    </ui-card>

    <!-- Employees -->
    <div class="ui table segment" *permission="viewPeoplePermission">
        <app-segment-header
            title="{{ 'company.office.employeesSectionHeader' | translate }}"
            [paginator]="paginator"
        ></app-segment-header>
        <!-- Empty State -->
        <div *ngIf="!paginator.total" class="empty">
            <img style="max-width: 20%" src="/assets/illustrations/sofa.png" />
            <h2 class="ui centered header">{{ 'company.office.noEmployeesInOfficeMessage' | translate }}</h2>
        </div>

        <!-- Content -->
        <table *ngIf="paginator.total" class="ui selectable table">
            <thead>
                <tr>
                    <th>{{ 'company.office.employeeFullNameColumn' | translate }}</th>
                    <th>{{ 'company.office.employeePositionColumn' | translate }}</th>
                    <th>{{ 'company.office.employeeStatusColumn' | translate }}</th>
                    <th>{{ 'company.office.employeeDepartmentColumn' | translate }}</th>
                    <th>{{ 'company.office.employeeHireDateColumn' | translate }}</th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let employee of paginator.values">
                    <tr [routerLink]="['/employees', 'directory', employee.id]">
                        <td>
                            <app-avatar [employee]="employee" [name]="true"></app-avatar>
                        </td>
                        <td>{{ employee.job?.title }}</td>
                        <td class="capitalize">{{ employee.status }}</td>
                        <td>{{ employee.department?.name }}</td>
                        <td>{{ employee?.hiredAt | appDate: 'mediumDate' }}</td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
    </div>
</div>
